import React, { useState, useEffect } from "react";
import { FaTh, FaBars, FaTasks } from "react-icons/fa";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import AdminNavbar from "./Admin-Navbar";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import apiUrl from "../Environment/Api";

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const { invoice_id } = useParams();
  const navigate = useNavigate();

  const userName = localStorage.getItem("name");
  const UserRole = localStorage.getItem("role");

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/invoiceadd") {
      setIsOpen(true);
    }
    if (location.pathname === "/add-taskmanagement") {
      setIsOpen(true);
    }
    if (location.pathname.startsWith("/update-taskmanagement")) {
      setIsOpen(true);
    }
    if (location.pathname === "/projectreport") {
      setIsOpen(true);
    }
    if (location.pathname.startsWith("/invoice/invoiceupdate/")) {
      setIsOpen(true);
    }
  }, [location.pathname, invoice_id]);

  const toggle = () => setIsOpen(!isOpen);

  const handleLogout = async () => {
    try {
      const response = await axios.post(apiUrl + "/logout");
      console.log(response.data);
      if (response.data.status === "success") {
        localStorage.removeItem("token");
        navigate("/");
        window.location.reload();
        setShowModal(false);
      } else {
        console.log("Error");
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const AllmenuItems = [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: <FaTh />,
    },
    {
      path: "/category",
      name: "Type",
      icon: <i className="fa-solid fa-layer-group"></i>,
    },
    {
      path: "/editors",
      name: "Editors",
      icon: <i className="fa-regular fa-pen-to-square"></i>,
    },
    {
      path: "/client-details",
      name: "Client Details",
      icon: <i className="fa-solid fa-user-tie"></i>,
    },
    {
      path: "/invoice",
      name: "Invoice",
      icon: <i className="fa-solid fa-file-invoice"></i>,
    },
    {
      path: "/task-management",
      name: "Task Management",
      icon: <FaTasks />,
    },
    {
      path: "/reports",
      name: "Income Reports",
      icon: <i className="fa-brands fa-wpforms"></i>,
    },
    {
      path: "/projectreport",
      name: "Project Reports",
      icon: <i className="fa-brands fa-wpforms"></i>,
    },
  ];

  const menuItem =
    UserRole === "editor"
      ? AllmenuItems.filter((item) =>
          ["/dashboard", "/task-management", "/projectreport"].includes(
            item.path,
          ),
        )
      : AllmenuItems;

  if (
    location.pathname === "/register" ||
    location.pathname === "/" ||
    location.pathname === "*" ||
    location.pathname.startsWith("/invoice/invoiceprint/") ||
    location.pathname.startsWith("/invoice/bill/")
  ) {
    return (
      <main
        style={{
          padding: isOpen ? "20px" : "0px",
          marginTop: isOpen ? "0px" : "0px",
        }}
      >
        {children}
      </main>
    );
  }

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <AdminNavbar toggle={toggle} />
      <Modal className="modal" show={showModal} onHide={handleCloseModal}>
        <Modal.Header>
          <p>Are you sure you want to logout?</p>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="container-main">
        <div
          className="sidebar"
          style={{
            position: "fixed",
            top: "70px",
            bottom: 0,
            left: 0,
            width: isOpen ? "50px" : "250px",
            zIndex: 1000,
          }}
        >
          <div className="top_section">
            <p style={{ display: isOpen ? "none" : "block" }} className="logo">
              <i className="fa-regular fa-circle-user sidebarusericon"></i>{" "}
              {UserRole?.charAt(0).toUpperCase() + UserRole?.slice(1)}
            </p>
            <div
              style={{ marginLeft: isOpen ? "7px" : "110px" }}
              className="bars"
            >
              <FaBars onClick={toggle} />
            </div>
          </div>
          {menuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className="link"
              activeClassName="active"
              style={{
                display: location.pathname === "/register" ? "none" : "flex",
              }}
            >
              <div className="icon">{item.icon}</div>
              <div
                style={{ display: isOpen ? "none" : "block" }}
                className="link_text"
              >
                {item.name}
              </div>
            </NavLink>
          ))}
          <div
            className="link"
            onClick={() => setShowModal(true)}
            style={{ cursor: "pointer" }}
          >
            <div className="icon">
              <i className="fa-solid fa-right-from-bracket"></i>
            </div>
            <div
              style={{ display: isOpen ? "none" : "block" }}
              className="link_text"
            >
              Logout
            </div>
          </div>
        </div>

        <main className={`main ${isOpen ? "isClose" : "isOpen"}`}>
          {children}
        </main>
      </div>
    </>
  );
};

export default Sidebar;
